module.exports = __webpack_public_path__ + "img/four_content_item_bg_02.9052a4a3.png";